import {Chip, Stack, Tooltip} from "@mui/material";
import React from "react";
import {styled} from "@mui/system";

import '../../css/App.css';
import ContextMenuButton from "./ContextMenuButton";
import {buildPerformerCheckInDetails} from "../../helpers/ShiftHelper";
import {useManualRefresh} from "../../hooks/useManualRefresh";
import {SESSION_TYPE} from "../../domain/SessionType";

const contextMenuButtonStyle = {
    zIndex: 1,
    alignItems: 'start',
    height: '100%'
};

const PerformerCheckInStatusChip = styled(Chip)(({ backgroundColor }) => ({
    display: "flex",
    justifyContent: "center",
    width: 24,
    height: 24,
    marginTop: 2,
    marginRight: 2,
    paddingLeft: 8.75,
    border: '0.03rem solid black',
    backgroundColor,
}));

export default function TimeslotUnbooked({id: componentId, onContextMenuClick, checkInStatusInfo, contextMenuButtonVisible, options, timeslotWrapper}) {

    const isCheckInSession = timeslotWrapper.session?.sessionType === SESSION_TYPE.CHECK_IN;
    
    const shouldDisplayContextMenuButton = contextMenuButtonVisible && options.enableContextMenu && !isCheckInSession;

    const {icon, color, tooltip: updatedTooltip} = buildPerformerCheckInDetails(
      timeslotWrapper.actualShiftStartTime,
      timeslotWrapper.shiftEndTime,
      checkInStatusInfo?.shifts[0]?.performerCheckInTime
    );
    
    // Due to react-calendar-timeline caching components, need to manually refresh the timeslot
    const REFRESH_TIME_SECONDS = 10;
    useManualRefresh(REFRESH_TIME_SECONDS);
    
    return <>
        {
          shouldDisplayContextMenuButton
          &&
          <Stack sx={contextMenuButtonStyle}>
              <ContextMenuButton id={componentId} onContextMenuClick={onContextMenuClick}/>
          </Stack>
        }
        {
          isCheckInSession
          &&
          <Stack sx={{ alignItems: 'end' }}>
              <Tooltip title={updatedTooltip}>
                  <PerformerCheckInStatusChip icon={icon} size="small" backgroundColor={color}/>
              </Tooltip>
          </Stack>
        }
    </>;
}
